import React from "react";

/**
 * FormCard — white card wrapper used in all ENIGOOTurnstiles form sections.
 * Props: children, marginBottom (default "14px")
 */
export const FormCard = ({children, marginBottom = "14px"}) => (
    <div style={{
        border: "1px solid #e2e8f0",
        borderRadius: "10px",
        background: "#fff",
        padding: "16px",
        marginBottom,
    }}>
        {children}
    </div>
);

/**
 * CardHeader — gray header bar used inside overflow:hidden card panels.
 * Props: title, right (optional right-side content — buttons, badges, etc.)
 */
export const CardHeader = ({title, right}) => (
    <div style={{
        padding: "10px 14px",
        background: "#f8fafc",
        borderBottom: "1px solid #e2e8f0",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    }}>
        <span style={{fontSize: "var(--enigoo-fs-sm)", fontWeight: 600, color: "#475569"}}>{title}</span>
        {right && (
            <div style={{display: "flex", gap: "8px", alignItems: "center"}}>
                {right}
            </div>
        )}
    </div>
);
